export enum AppRoute {
  Home = '/',
  NoMatch = '*',
}
